export default function newTabLinks(selector) {
  document.querySelectorAll(selector).forEach(link => {
    if (link.href && /\.(pdf|doc|docx|ppt|pptx|xls|xlsx)$/i.test(link.href)) {
      link.target = '_blank';
    }
  });
}
